var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgDanger = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  style: {
    isolation: "isolate"
  },
  viewBox: "430 253 80 80",
  width: 80,
  height: 80,
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  vectorEffect: "non-scaling-stroke",
  cx: 469.99999999999994,
  cy: 292.9999999999999,
  r: 39,
  fill: "none",
  strokeWidth: 2,
  stroke: "#ff494c",
  strokeLinejoin: "miter",
  strokeLinecap: "butt",
  strokeMiterlimit: 4
}), /*#__PURE__*/React.createElement("line", {
  x1: 482.374,
  y1: 280.626,
  x2: 457.626,
  y2: 305.374,
  vectorEffect: "non-scaling-stroke",
  strokeWidth: 2,
  stroke: "#ff494c",
  strokeLinejoin: "miter",
  strokeLinecap: "butt",
  strokeMiterlimit: 4
}), /*#__PURE__*/React.createElement("line", {
  x1: 457.626,
  y1: 280.626,
  x2: 482.374,
  y2: 305.374,
  vectorEffect: "non-scaling-stroke",
  strokeWidth: 2,
  stroke: "#ff494c",
  strokeLinejoin: "miter",
  strokeLinecap: "butt",
  strokeMiterlimit: 4
}))))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDanger, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/danger.a1269c06.svg";
export { ForwardRef as ReactComponent };